/**
 * Convert camel case to hyphen case
 * @example camelToHyphenCase('camelCase') => 'camel-case'
 *
 * @param text
 * @returns {string}
 */
export function camelToHyphenCase(text: string): string {
  return text.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

/**
 * Convert hyphen case to camel case
 * @example hyphenToCamelCase('hyphen-case') => 'hyphenCase'
 *
 * @param text
 * @returns {string}
 */
export function hyphenToCamelCase(text: string): string {
  return text.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
}

export function searchByTerm(searchTerm: string, text: string) {
  return text.toLowerCase().includes(searchTerm.toLowerCase());
}

export function searchByTerms(searchTerm: string, values: string[]): boolean {
  const trimmedSearchTerm = searchTerm.trim().toLowerCase();
  const normalizedSearchTerm = normalizeString(trimmedSearchTerm);

  return values.some((value) => value.trim().toLowerCase().includes(normalizedSearchTerm));
}

export const normalizeString = (text: string) =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/_/g, " ")
    .toLowerCase();

export const formatSpaceFour = (input: string) => {
  const formattedStr = input.replace(/ /g, "");
  const slices = formattedStr.match(/.{1,4}/g);
  return slices?.join(" ") || "";
};

export const removeHyphens = (text: string) => text.replace(/-/g, " ");

export const formatSelectedCount = (
  count: number,
  emptyLabel: string,
  singularLabel = "sélectionné",
  pluralLabel = "sélectionnés",
): string => {
  if (count === 0) return emptyLabel;
  return `${count} ${count === 1 ? singularLabel : pluralLabel}`;
};
